import {Link} from "react-router-dom";
import Menu from "./Menu";
import noise from "../../contents/dev/noise.png"
import {useState} from "react";
import ButtonSwitcher from './HeaderSwitcher'
import MobileNavMenu from "./MobileNavMenu";
import {useEffect} from "react"

export default function SiteHeader({toggleFooter}) {
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 640px)');
        const handleResize = () => {
            if (mediaQuery.matches) {
                setIsOpen(false);
            }
        };
        mediaQuery.addEventListener('change', handleResize);
        return () => mediaQuery.removeEventListener('change', handleResize);
    }, [])
    return (
        <header className='h-24 relative bg-gray-1 border-b-2 border-gray-2 w-full'
                style={{zIndex: 50, backgroundImage: `url(${noise})`}}>
            <div className="h-full  px-4 sm:px-10 md:px-20 lg:px-32 2xl:px-40 content flex w-full items-center sm:justify-between">
                <div className="block flex items-center sm:hidden">
                    <button
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                        style={{touchAction: 'manipulation'}}
                        className="h-6 w-10 flex justify-center items-center mr-10 bg-yellow-400">
                        {!isOpen ?
                            <svg width="18" height="14" viewBox="0 0 22 14" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1H21" stroke="#29292B" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M1 7H21" stroke="#29292B" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M1 13H21" stroke="#29292B" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            :
                            <svg width="14" height="14" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 15.1421L15.1421 0.999954" stroke="#29292B" strokeWidth="2"
                                      strokeLinecap="round"/>
                                <path d="M15.1406 15.1421L0.998489 0.999954" stroke="#29292B" strokeWidth="2"
                                      strokeLinecap="round"/>
                            </svg>
                        }
                    </button>

                </div>
                
                <Link to="home">
                    <span className='lg:text-2xl text-white font-bold font-sans'>3Dot</span>
                    <span className='lg:text-2xl text-yellow-400 font-bold font-sans'>Studio</span>
                </Link>
                <Menu/>
                <button className="hidden sm:flex">
                    <a className="flex items-center space-x-2" target="_blank" rel="noopener noreferrer" href = "mailto: sales@3dotstudio.info">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M28.5477 3.45117H3.44975C1.72426 3.45117 0.328186 4.86294 0.328186 6.58842L0.3125 25.412C0.3125 27.1374 1.72426 28.5492 3.44975 28.5492H28.5477C30.2733 28.5492 31.685 27.1374 31.685 25.412V6.58842C31.685 4.86294 30.2733 3.45117 28.5477 3.45117ZM27.9203 10.1178L16.8302 17.0512C16.3282 17.3649 15.6694 17.3649 15.1674 17.0512L4.07721 10.1178C3.68504 9.86686 3.44975 9.44333 3.44975 8.98842C3.44975 7.93745 4.59486 7.31 5.48897 7.85901L15.9988 14.4316L26.5086 7.85901C27.4027 7.31 28.5477 7.93745 28.5477 8.98842C28.5477 9.44333 28.3124 9.86686 27.9203 10.1178Z"
                                fill="white"/>
                        </svg>
                        <div className="text-white hover:text-yellow-400 transition-colors hidden lg:block">sales@3dotstudio.info</div>
                    </a>
                </button>
                <ButtonSwitcher/>
            </div>
            <MobileNavMenu isOpen={isOpen}/>

        </header>
    );
}